export default __webpack_public_path__ + "static/media/calendarIconBlack.be731232.svg";